<template>
    <div class="flex items-center py-4 md:py-2 flex-row" :class="!registration && !last ? 'border-b-2' : ''">
        <div class="md:flex flex-row items-center md:flex-1">
            <p class="md:mr-auto">
                <img v-if="price.image" class="max-h-8 max-w-[7rem] md:max-w-[7rem] lg:max-w-[10rem]" :src="price.image">

                <template v-else>{{ price.website_name }}</template>
            </p>

            <p class="text-dark text-lg text-right md:mr-4 md:ml-auto md:min-w-[10rem] lg:min-w-[8rem]">
                <span>From </span>
                <span class="font-bold">£{{ price.retail }}</span>
            </p>
        </div>

        <a v-if="price.url" :href="price.url" target="_blank" class="ml-auto">
            <AppButton :theme="registration ? 'primary' : 'secondary'" type="button">
                Buy now
            </AppButton>
        </a>
    </div>
</template>

<script>
import AppButton from "@/Components/AppButton";

export default {
    components: {AppButton},
    props: {
        price: Object,
        registration: String
    },
    data: () => ({
        last: false,
    }),
    mounted() {
        this.last = this.price[this.price.length - 1] === this
    },
    computed: {
        image() {
            return `/images/logos/tyre-sites/${this.price.website_slug}.png`;
        }
    }
}
</script>

<style scoped>

</style>
